<template>
  <div class="footer-box">
    <div>Trusted Provider of Market Leading Test Development and Delivery Solutions</div>
    <!-- <div>©2024 Prometric</div> -->
    <div>京ICP备10026361号 | ©{{ CurrentYear }} Prometric</div>
  </div>
</template>
<script>
export default {
  name: 'MyFooter',
  data() {
    return {}
  },
  created() {},
  computed: {
    CurrentYear() {
      return new Date().getFullYear()
    },
  },
  methods: {},
}
</script>
<style lang="less" scoped>
.footer-box {
  position: fixed;
  bottom: 0;
  width: 100%;
  padding: 0 10px;
  height: @footer-height;
  border-top: solid 2px @primary-color;
  border-top-width: medium;
  background-color: black;
  color: #ffffff;
  font-weight: 600;
  text-align: center;
  z-index: 99;
  .flex_arrange(row, space-between);
  & > div:nth-child(2) {
    color: @primary-color;
  }
}
@media (max-width: 840px) {
  .footer-box {
    height: @footer-height-phone;
    flex-direction: column;
    padding: 10px;
  }
}
</style>
